import { IBreastDashboard } from "models/breast";
import { IMDTDashboard } from "models/mdt";
import { IMDTDashboard as NoMDTDashboard } from "models/noMdt";
import { IMDTDashboard as CRCDashboard } from "models/crc";
import { IBrainDashboard as BrainDashboard } from "models/brain";
import { IUserSettings } from "models";
import { ILungDashboard } from "models/lung";
import { IHeadAndNeckDashboard } from "models/headAndNeck";
import { IYouthCancerDashboard } from "models/youthCancer";
import { IAMLDashboard } from "models/aml";

export enum ActionTypes {
	UserWantsToLoadMdtDashboard,
	UserLoadedMdtDashboard,
	UserClickedOnChart,
	UserClearedFilters,
	ShowInternalLinks,
	ApiGetUserSettings,
	ComputingChartData,
	UserWantsToNavigate
}

export type Actions =
	| { type: ActionTypes.UserLoadedMdtDashboard, payload: (IMDTDashboard | NoMDTDashboard | CRCDashboard | IBreastDashboard | ILungDashboard | BrainDashboard | IHeadAndNeckDashboard | IAMLDashboard | IYouthCancerDashboard) }
	| { type: ActionTypes.UserWantsToLoadMdtDashboard }
	| { type: ActionTypes.UserClickedOnChart, payload: (IMDTDashboard | NoMDTDashboard | CRCDashboard | IBreastDashboard | ILungDashboard | BrainDashboard | IHeadAndNeckDashboard | IAMLDashboard | IYouthCancerDashboard) }
	| { type: ActionTypes.UserClearedFilters, payload: (IMDTDashboard | NoMDTDashboard | CRCDashboard | IBreastDashboard | ILungDashboard | BrainDashboard | IHeadAndNeckDashboard | IAMLDashboard | IYouthCancerDashboard) }
	| { type: ActionTypes.ApiGetUserSettings, payload: IUserSettings }
	| { type: ActionTypes.ShowInternalLinks, payload: boolean }
	| { type: ActionTypes.ComputingChartData }
	| { type: ActionTypes.UserWantsToNavigate }
